/**
 * Shared helpers for task search grids that map Yes/No chip selections to API booleans
 * and filter tree rows consistently (Global Search Tasks + Mods Link Task Search).
 */

export const getSingleBooleanFilterValue = (selections: unknown): boolean | undefined => {
  if (!Array.isArray(selections)) return undefined;
  const hasYes = selections.some(opt => opt?.value === true);
  const hasNo = selections.some(opt => opt?.value === false);
  if (hasYes === hasNo) return undefined;
  return hasYes;
};

export const matchesBooleanFilter = (
  value: boolean | null | undefined,
  activeFilter: boolean | undefined,
): boolean => activeFilter == null || value === activeFilter;
